import { Validator } from "../validator"

export enum BusinessNatureError {
    BLANK = `invalid_input`,
}

class BusinessNatureValidator implements Validator<string, BusinessNatureError> {
    validate(entry: string): BusinessNatureError | undefined {
        if (entry === ``) {
            return BusinessNatureError.BLANK
        }
    }
}
export { BusinessNatureValidator }